import { useCallback, useEffect, useMemo, useState } from 'react'
import moment from 'moment'

export default function useCountDown(time: number) {
  const { now } = useNow()

  return useMemo(() => time - now, [time, now])
}

export function useCountDownData(time: number) {
  const ts = useCountDown(time)
  return useMemo(() => {
    const day = Math.floor(ts / 86400)
      .toString()
      .padStart(2, '0')
    const hour = Math.floor((ts % 86400) / 3600)
      .toString()
      .padStart(2, '0')
    const min = Math.floor((ts % 3600) / 60)
      .toString()
      .padStart(2, '0')
    const sec = Math.floor(ts % 60)
      .toString()
      .padStart(2, '0')
    return { day, hour, min, sec }
  }, [ts])
}

export function useNow() {
  const [now, setNow] = useState(() => {
    return moment().unix()
  })
  const [inter, setInter] = useState<number>(0)
  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow((prevState) => prevState + 1)
    }, 1000)
    setInter(interval)
    return () => {
      window.clearInterval(interval)
    }
  }, [setNow, setInter])
  const stop = useCallback(() => {
    window.clearInterval(inter)
  }, [inter])
  return { now, stop }
}
